
export abstract class BaseRepository<Entity> {

    public abstract list(): Promise<Entity[]>;
    public abstract get(id: any): Promise<Entity>;

    /**
     * Update the data in the repository (not implemented!)
     * @param data
     */
    public update(data: Entity): Promise<Entity> {
        throw new Error('update is not implemented');
    }

    /**
     * Convert any object to a date if not null
     * @param input
     */
    protected static anyToDate(input: any): Date {
        return input != null ? new Date(input) : null;
    }
}